import { Vector } from "../../math";
// TODO: refactor to mutable VectorArrow objects - update mechanism
var VectorArrow = /** @class */ (function () {
    function VectorArrow(v0, v1, color, name) {
        this.start = v0 || new Vector([0, 0]);
        this.vector = v1;
        this.color = color || '#000000';
        this.name = name || 'a';
    }
    Object.defineProperty(VectorArrow.prototype, "end", {
        get: function () {
            if (this.renderVector) {
                return this.start.add(this.renderVector);
            }
            else {
                return this.start.add(this.vector);
            }
        },
        enumerable: true,
        configurable: true
    });
    VectorArrow.prototype.drawCanvas = function (ctx) {
        var size = 10;
        var width = 0.7;
        var a = Math.atan(this.vector.y / this.vector.x);
        ctx.strokeStyle = this.color;
        ctx.fillStyle = this.color;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(this.start.x, this.start.y);
        ctx.lineTo(this.end.x, this.end.y);
        ctx.moveTo(this.end.x, this.end.y);
        var dxLeft = Math.cos(a - width) * size;
        var dxRight = Math.cos(a + width) * size;
        var dyTop = Math.sin(a - width) * size;
        var dyBottom = Math.sin(a + width) * size;
        if (this.vector.x < 0) {
            ctx.lineTo(this.end.x + dxLeft, this.end.y + dyTop);
            ctx.lineTo(this.end.x + dxRight, this.end.y + dyBottom);
        }
        else {
            ctx.lineTo(this.end.x - dxLeft, this.end.y - dyTop);
            ctx.lineTo(this.end.x - dxRight, this.end.y - dyBottom);
        }
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    };
    return VectorArrow;
}());
export default VectorArrow;
//# sourceMappingURL=vector.js.map